function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "M11.554 11.553v-6.92L5.85.146.146 4.632v6.921h11.408z"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref);
}

export default SvgHome;